<template>
    <div class="cookie_bar" v-if="show">
        <cookie-modal v-if="type !== undefined && type === 'modal'" @confirm="confirm"></cookie-modal>
        <cookie-banner v-if="type !== undefined && type === 'banner'" @confirm="confirm"></cookie-banner>
    </div>
</template>

<script>
    import Vue from 'vue';
    import Component from 'vue-class-component';
    import CookieModal from './CookieModal.vue';
    import CookieBanner from './CookieBanner.vue';

    @Component
    export default class CookieNotification extends Vue {
        name = 'cookie-notification';

        show = false;
        type = undefined;

        created() {
            var local = this.getLocalStorage();
            if (this.cookies && this.config.cookies.enabled && !local) {
                this.show = true;
                this.type = this.config.cookies.type;
            }
        }

        getLocalStorage() {
            var item = localStorage.getItem('cookies');
            if (!item) {
                return false;
            } else {
                return JSON.parse(item);
            }
        }

        mounted() {
            if (this.type === 'modal') {
                console.log('[ Cookies ]', 'Should show modal');
                this.$modal.show('cookie-modal');
            }
        }

        confirm() {
            console.log('[ Cookies ]', 'confirm');
            localStorage.setItem('cookies', true);
            this.show = false;
        }
    }

    Vue.component('cookie-notification', CookieNotification);
</script>





// WEBPACK FOOTER //
// src/components/cookies/CookieNotification.vue